import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_Attribution from 'ol/control/Attribution';

import { Util } from '../util';
import Map from '../map';

export class Attribution extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            target: undefined,
            collapsible: undefined,
            collapsed: undefined,
            tipLabel: undefined,
            label: undefined,
            collapseLabel: undefined,
            render: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_Attribution(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
Attribution['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};